import Root from './Root'

function App() {
  return (
    <Root/>
  );
}

export default App;
